import { render, staticRenderFns } from "./caDetection.vue?vue&type=template&id=44dedb2f&scoped=true"
import script from "./caDetection.vue?vue&type=script&lang=js"
export * from "./caDetection.vue?vue&type=script&lang=js"
import style0 from "./caDetection.vue?vue&type=style&index=0&id=44dedb2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dedb2f",
  null
  
)

export default component.exports